"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { LabelH2, LabelH3, P, Title } from "@motorata/base-ui.components.atoms.typography";
import { useForm } from "react-hook-form";
import Select from "@motorata/base-ui.components.atoms.select";
import {
  ASSISTANT_ARRAY,
  BODY_TYPE_CAR_ARRAY,
  BODY_TYPE_MOTO_ARRAY,
  BODY_TYPE_TRUCK_ARRAY,
  BRANDS_ARRAY,
  BRANDS_MOTO_ARRAY,
  COLOR_TYPES_ARRAY,
  COLORS_ARRAY, COMFORT_ARRAY,
  COUNTRY_ARRAY,
  FUEL_ARRAY,
  FUEL_MOTO_ARRAY,
  GEAR_ARRAY,
  GEAR_MOTO_ARRAY,
  MODELS_ARRAY, MULTIMEDIA_ARRAY, SECURITY_ARRAY, translateBrand, translateModel, YEAR_ARRAY
} from "@motorata/base-ui.data";
import Input from "@motorata/base-ui.components.atoms.input";
import Button from "@motorata/base-ui.components.atoms.button";
import CheckboxesGroup from "@motorata/base-ui.components.atoms.checkboxes-group";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import Modal from "@motorata/base-ui.components.molecules.modal";
import Link from "@motorata/next.components.atoms.link";
import { useRouter } from "next/navigation";
import { ModelService } from "../../services/ModelService";
import { UserService } from "../../services/UserService";
import { NextImage } from "@/components/common/Image";
import AddOfferGallery from "@/views/account/components/AddOfferGallery";
import AddOfferVinDecoder from "@/views/account/components/AddOfferVinDecoder";
import { VinDecoderService } from "@/services/VinDecoderService";

const MotoInformations = ({ watch, setValue, errors, register }) => {
  const [brands, setBrands] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [gearBoxes, setGearBoxes] = useState([]);

  const type = watch("type");
  const year = watch("year");
  const brand = watch("brand");
  const model = watch("model");
  const bodyType = watch("bodyType");
  const fuelType = watch("fuelType");
  const enginePower = watch("enginePower");
  const engineCapacity = watch("engineCapacity");
  const gearBox = watch("gearBox");

  useEffect(() => {
    setBrands([]);
    setValue("brand", "");
    if (year) {
      setBrands(BRANDS_MOTO_ARRAY);
    }
  }, [year]);

  useEffect(() => {
    setBodyTypes([]);
    setValue("bodyType", "");
    if (model) {
      setBodyTypes(BODY_TYPE_MOTO_ARRAY);
    }
  }, [model]);

  useEffect(() => {
    setFuelTypes([]);
    setValue("fuelType", "");
    if (bodyType) {
      setFuelTypes(FUEL_MOTO_ARRAY);
    }
  }, [bodyType]);

  useEffect(() => {
    setGearBoxes([]);
    setValue("gearBox", "");
    if (fuelType) {
      setGearBoxes(GEAR_MOTO_ARRAY);
    }
  }, [fuelType]);

  return (
    <>
      <Select
        name="year"
        disabled={!type}
        label="Rok modelowy*"
        options={YEAR_ARRAY}
        value={year}
        margin="0"
        error={errors.year}
        rhf={register("year", { required: true })}
      />
      <Select
        name="brand"
        disabled={!year}
        label="Marka*"
        options={brands}
        value={brand}
        margin="0"
        error={errors.brand}
        rhf={register("brand", { required: true })}
      />
      <Input
        name="model"
        disabled={!brand}
        label="Model*"
        value={model}
        error={errors.model}
        rhf={register("model", { required: false })}
      />
      <Select
        name="bodyType"
        disabled={!model}
        label="Nadwozie*"
        options={bodyTypes}
        value={bodyType}
        margin="0"
        error={errors.bodyType}
        rhf={register("bodyType", { required: true })}
      />
      <Select
        name="fuelType"
        disabled={!bodyType}
        label="Rodzaj paliwa*"
        options={fuelTypes}
        value={fuelType}
        margin="0"
        error={errors.fuelType}
        rhf={register("fuelType", { required: true })}
      />
      <Select
        name="gearBox"
        disabled={!fuelType}
        label="Skrzynia biegów*"
        options={gearBoxes}
        value={gearBox}
        margin="0"
        error={errors.gearBox}
        rhf={register("gearBox", { required: true })}
      />
      <Input
        name="enginePower"
        disabled={!gearBox}
        elementType="numeric"
        label="Moc*"
        endAdornment="KM"
        value={enginePower}
        error={errors.enginePower}
        rhf={register("enginePower", { required: true })}
      />
      <Input
        name="engineCapacity"
        disabled={!enginePower}
        elementType="numeric"
        label="Pojemność*"
        endAdornment="cm3"
        value={engineCapacity}
        error={errors.engineCapacity}
        rhf={register("engineCapacity", { required: true })}
      />
    </>
  );
};

const TruckInformations = ({ watch, setValue, errors, register }) => {
  const [brands, setBrands] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [gearBoxes, setGearBoxes] = useState([]);

  const type = watch("type");
  const year = watch("year");
  const brand = watch("brand");
  const model = watch("model");
  const bodyType = watch("bodyType");
  const fuelType = watch("fuelType");
  const enginePower = watch("enginePower");
  const engineCapacity = watch("engineCapacity");
  const gearBox = watch("gearBox");

  useEffect(() => {
    setBrands([]);
    setValue("brand", "");
    if (year) {
      setBrands(BRANDS_ARRAY);
    }
  }, [year]);

  useEffect(() => {
    setBodyTypes([]);
    setValue("bodyType", "");
    if (model) {
      setBodyTypes(BODY_TYPE_TRUCK_ARRAY);
    }
  }, [model]);

  useEffect(() => {
    setFuelTypes([]);
    setValue("fuelType", "");
    if (bodyType) {
      setFuelTypes(FUEL_ARRAY);
    }
  }, [bodyType]);

  useEffect(() => {
    setGearBoxes([]);
    setValue("gearBox", "");
    if (fuelType) {
      setGearBoxes(GEAR_ARRAY);
    }
  }, [fuelType]);

  return (
    <>
      <Select
        name="year"
        disabled={!type}
        label="Rok modelowy*"
        options={YEAR_ARRAY}
        value={year}
        margin="0"
        error={errors.year}
        rhf={register("year", { required: true })}
      />
      <Select
        name="brand"
        disabled={!year}
        label="Marka*"
        options={brands}
        value={brand}
        margin="0"
        error={errors.brand}
        rhf={register("brand", { required: true })}
      />
      <Input
        name="model"
        disabled={!brand}
        label="Model*"
        value={model}
        error={errors.model}
        rhf={register("model", { required: false })}
      />
      <Select
        name="bodyType"
        disabled={!model}
        label="Nadwozie*"
        options={bodyTypes}
        value={bodyType}
        margin="0"
        error={errors.bodyType}
        rhf={register("bodyType", { required: true })}
      />
      <Select
        name="fuelType"
        disabled={!bodyType}
        label="Rodzaj paliwa*"
        options={fuelTypes}
        value={fuelType}
        margin="0"
        error={errors.fuelType}
        rhf={register("fuelType", { required: true })}
      />
      <Select
        name="gearBox"
        disabled={!fuelType}
        label="Skrzynia biegów*"
        options={gearBoxes}
        value={gearBox}
        margin="0"
        error={errors.gearBox}
        rhf={register("gearBox", { required: true })}
      />
      <Input
        name="enginePower"
        disabled={!gearBox}
        elementType="numeric"
        label="Moc*"
        endAdornment="KM"
        value={enginePower}
        error={errors.enginePower}
        rhf={register("enginePower", { required: true })}
      />
      <Input
        name="engineCapacity"
        disabled={!enginePower}
        elementType="numeric"
        label="Pojemność*"
        endAdornment="cm3"
        value={engineCapacity}
        error={errors.engineCapacity}
        rhf={register("engineCapacity", { required: true })}
      />
    </>
  );
};

const CarInformations = ({ decodedCar, watch, setValue, errors, register }) => {
  const [loading, setLoading] = useState<string | boolean>(false);

  const [models, setModels] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [gearBoxes, setGearBoxes] = useState([]);
  const [enginePowers, setEnginePowers] = useState(null);
  const [engineCapacities, setEngineCapacities] = useState(null);
  const [versions, setVersions] = useState([]);

  const type = watch("type");
  const year = watch("year");
  const brand = watch("brand");
  const model = watch("model");
  const bodyType = watch("bodyType");
  const fuelType = watch("fuelType");
  const enginePower = watch("enginePower");
  const engineCapacity = watch("engineCapacity");
  const gearBox = watch("gearBox");
  const version = watch("version");

  useEffect(() => {
    setModels([]);
    setValue("model", "");
    if (brand) {
      setModels(MODELS_ARRAY[brand]);
    }
  }, [brand]);

  useEffect(() => {
    setBodyTypes([]);
    setValue("bodyType", "");
    if (model) {
      setBodyTypes(BODY_TYPE_CAR_ARRAY);
    }
  }, [model]);

  useEffect(() => {
    setFuelTypes([]);
    setValue("fuelType", "");
    if (bodyType) {
      setFuelTypes(FUEL_ARRAY);
    }
  }, [bodyType]);

  useEffect(() => {
    setGearBoxes([]);
    setValue("gearBox", "");
    if (fuelType) {
      setGearBoxes(GEAR_ARRAY);
    }
  }, [fuelType]);

  useEffect(() => {
    const fetch = async () => {
      setEnginePowers(null);
      setValue("enginePower", "");
      if (year && fuelType && gearBox) {
        // setLoading("enginePower")
        const res = await ModelService.getEnginePowers(year, brand, model, fuelType);
        setEnginePowers(res);
        // setLoading(false)
      }
    };

    fetch();
  }, [gearBox]);

  useEffect(() => {
    const fetch = async () => {
      setEngineCapacities(null);
      setValue("engineCapacity", "");
      if (enginePower) {
        // setLoading("engineCapacity")
        const res = await ModelService.getEngineCapacities(year, brand, model, fuelType, enginePower);
        setEngineCapacities(res);
        // setLoading(false)
      }
    };

    fetch();
  }, [enginePower]);

  useEffect(() => {
    const fetch = async () => {
      setVersions(null);
      setValue("version", "");
      if (engineCapacity) {
        setLoading("version");
        const res = await ModelService.getVersions(
          year,
          brand,
          model,
          fuelType,
          gearBox,
          enginePower,
          engineCapacity
        );
        // @ts-ignore
        setVersions(res);
        setLoading(false);
      }
    };

    fetch();
  }, [engineCapacity]);

  return (
    <>
      <Select
        name="year"
        disabled={decodedCar ? true : !type}
        label="Rok modelowy*"
        options={decodedCar ? [
          [decodedCar.year, decodedCar.year]
        ] : YEAR_ARRAY}
        value={decodedCar ? decodedCar.year : year}
        margin="0"
        error={decodedCar?.year ? false : errors.year}
        rhf={register("year", { required: !decodedCar })}
      />
      <Select
        name="brand"
        disabled={decodedCar ? true : !year}
        label="Marka*"
        options={decodedCar ? [
          [translateBrand(decodedCar.brand), decodedCar.brand]
        ] : BRANDS_ARRAY}
        value={decodedCar ? decodedCar.brand : brand}
        margin="0"
        error={decodedCar?.brand ? false : errors.brand}
        rhf={register("brand", { required: !decodedCar })}
      />
      <Select
        name="model"
        disabled={decodedCar ? true : !brand}
        label="Model*"
        options={decodedCar ? [
          [translateModel(decodedCar.model), decodedCar.model]
        ] : models}
        value={decodedCar ? decodedCar.model : model}
        margin="0"
        error={decodedCar?.model ? false : errors.model}
        rhf={register("model", { required: !decodedCar })}
      />
      <Select
        name="bodyType"
        disabled={decodedCar ? false : !model}
        label="Nadwozie*"
        options={decodedCar ? BODY_TYPE_CAR_ARRAY : bodyTypes}
        value={bodyType}
        margin="0"
        error={errors.bodyType}
        rhf={register("bodyType", { required: true })}
      />
      <Select
        name="fuelType"
        disabled={decodedCar ? !!decodedCar.fuelType : !bodyType}
        label="Rodzaj paliwa*"
        options={decodedCar ? FUEL_ARRAY : fuelTypes}
        value={decodedCar?.fuelType ? decodedCar.fuelType : fuelType}
        margin="0"
        error={decodedCar?.fuelType ? false : errors.fuelType}
        rhf={register("fuelType", { required: !decodedCar?.fuelType })}
      />
      <Select
        name="gearBox"
        disabled={decodedCar ? !!decodedCar?.gearBox : !fuelType}
        label="Skrzynia biegów*"
        options={decodedCar ? GEAR_ARRAY : gearBoxes}
        value={decodedCar?.gearBox ? decodedCar.gearBox : gearBox}
        margin="0"
        error={decodedCar?.gearBox ? false : errors.gearBox}
        rhf={register("gearBox", { required: !decodedCar?.gearBox })}
      />
      {(!enginePowers || enginePowers?.length > 0) && !decodedCar ? (
        <Select
          name="enginePower"
          disabled={!gearBox || enginePowers?.length === 0}
          label="Moc*"
          options={enginePowers?.map(el => [`${el} KM`, el])}
          margin="0"
          error={errors.enginePower}
          rhf={register("enginePower", { required: true })}
        />
      ) : (
        <Input
          name="enginePower"
          elementType="numeric"
          label="Moc*"
          disabled={!!decodedCar?.enginePower}
          endAdornment="KM"
          value={decodedCar?.enginePower ? decodedCar.enginePower : enginePower}
          error={decodedCar?.enginePower ? false : errors.enginePower}
          rhf={register("enginePower", { required: !decodedCar?.enginePower })}
        />
      )}
      {(!engineCapacities || engineCapacities?.length > 0) && !decodedCar ? (
        <Select
          name="engineCapacity"
          disabled={!enginePower || engineCapacities?.length === 0}
          label="Pojemność*"
          options={engineCapacities?.map(el => [`${el} cm3`, el])}
          margin="0"
          error={errors.engineCapacity}
          rhf={register("engineCapacity", { required: true })}
        />
      ) : (
        <Input
          name="engineCapacity"
          elementType="numeric"
          disabled={!!decodedCar?.engineCapacity}
          label="Pojemność*"
          endAdornment="cm3"
          value={decodedCar?.engineCapacity ? decodedCar.engineCapacity : engineCapacity}
          error={decodedCar?.engineCapacity ? false : errors.engineCapacity}
          rhf={register("engineCapacity", { required: !decodedCar?.engineCapacity })}
        />
      )}
      {(!versions || versions?.length > 0) && !decodedCar ? (
        <Select
          name="version"
          disabled={!engineCapacity || versions?.length === 0}
          label="Wersja*"
          options={versions?.map(el => [`${el}`, el])}
          margin="0"
          error={errors.version}
          rhf={register("version", { required: true })}
        />
      ) : (
        <Input
          name="version"
          label="Wersja*"
          value={version}
          error={errors.version}
          rhf={register("version", { required: true })}
        />
      )}
    </>
  );
};

const AccountAddOffer = () => {
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset
  } = useForm({
    defaultValues: {
      type: "car",
      year: "",
      brand: "",
      model: "",
      bodyType: "",
      fuelType: "",
      enginePower: "",
      engineCapacity: "",
      gearBox: "",
      version: "",
      state: "",
      course: "",
      color: "",
      colorType: "",
      country: "polska",
      vin: "",
      price: "",
      youtube: "",
      description: ""
    }
  });

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const [equipmentState, setEquipmentState] = useState("security");
  const [equipment, setEquipment] = useState([]);
  const [invoice, setInvoice] = useState("none");
  const [images, setImages] = useState([]);

  const timeoutId = useRef<number | null>();
  const [vinText, setVinText] = useState("");
  const [decodeResponse, setDecodeResponse] = useState(null);
  const [decodeResponseStatus, setDecodeResponseStatus] = useState<null | string>(null);
  const [loadingDecode, setLoadingDecode] = useState(false);

  const type = watch("type");
  const state = watch("state");
  const course = watch("course");
  const color = watch("color");
  const colorType = watch("colorType");
  const country = watch("country");
  const price = watch("price");
  const youtube = watch("youtube");
  const description = watch("description");

  const onSubmit = useCallback(async (el) => {
    try {
      setLoading(true);
      let body = {
        state: el.state,
        type: el.type,
        year: el.year,
        brand: el.brand,
        model: el.model,
        bodyType: el.bodyType,
        fuelType: el.fuelType,
        gearBox: el.gearBox,
        enginePower: el.enginePower,
        engineCapacity: el.engineCapacity,
        version: el.version,
        course: el.course && el.course !== "" ? el.course : "0",
        isAvailable: true,
        isDamaged: false,
        params: {
          color: el.color,
          colorType: el.colorType,
          vin: el.vin,
          country: el.country
        },
        finance: {
          price: el.price,
          type: "gross",
          invoice: invoice
        },
        images: images?.filter(el => !el.isUploading).map(el => el.id),
        youtube: el.youtube,
        equipment: equipment,
        description: el.description
      };

      if (decodeResponse) {
        body = {
          ...body,
          year: decodeResponse.year ?? body.year,
          brand: decodeResponse.brand ?? body.brand,
          model: decodeResponse.model ?? body.model,
          fuelType: decodeResponse.fuelType ?? body.fuelType,
          gearBox: decodeResponse.gearBox ?? body.gearBox,
          enginePower: decodeResponse.enginePower ?? body.enginePower,
          engineCapacity: decodeResponse.engineCapacity ?? body.engineCapacity,
          params: {
            ...body?.params,
            vin: vinText
          }
        };
      }

      const offer = await UserService.addOffer(body);
      setData(offer);
    } catch (e) {
      alert("Nie udało się dodać ogłoszenia. Proszę spróbować później.");
      SentryService.error("[ERROR UserService.addOffer API]", e);
    } finally {
      setLoading(false);
    }
  }, [invoice, equipment, images, decodeResponse, vinText]);

  const fetchVin = async (vin: string) => {
    try {
      setLoadingDecode(true);
      setDecodeResponse(null);
      setDecodeResponseStatus(null);
      const decoded = await VinDecoderService.decode(vin);
      console.log(decoded);
      setDecodeResponse(decoded);
      setDecodeResponseStatus("success");
    } catch (e) {
      setDecodeResponse(null);
      setDecodeResponseStatus("error");
      console.log(e);
    } finally {
      setLoadingDecode(false);
    }
  };

  useEffect(() => {
    setValue("year", "");
    setValue("brand", "");
    setValue("model", "");
    setValue("bodyType", "");
    setValue("fuelType", "");
    setValue("gearBox", "");
    setValue("enginePower", "");
    setValue("engineCapacity", "");
    setValue("version", "");
  }, [type]);

  useEffect(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    // @ts-ignore
    timeoutId.current = setTimeout(() => {
      if (vinText && vinText !== "") {
        fetchVin(vinText);
      }
    }, 1000);
  }, [vinText]);

  const handleEquipmentAuto = () => {
    setEquipment([
      "antilock_brake_system",
      "esp",
      "active_emergency_brake_assist",
      "driver_airbag",
      "passenger_airbag",
      "side_airbag_driver_and_passenger",
    ])
  }

  return (
    <>
      <Title label="Panel">Dodaj ogłoszenie</Title>
      <Wrapper>
        <Content>
          <Box marginBottom="S">
            <LabelH2 fontSize="XL" margin="0">Podstawowe informacje</LabelH2>
            <P small>Podaj podstawowe informacje o pojeździe</P>
          </Box>
          {type === "car" &&
            <AddOfferVinDecoder status={decodeResponseStatus}>
              <Input width="100%" maxWidth="350px" name="vin" loading={loadingDecode} label="VIN" background="white"
                     onChange={({ value }) => setVinText(value)} />
            </AddOfferVinDecoder>
          }
          <Grid>
            <Select
              name="type"
              label="Rodzaj"
              options={[
                ["Osobowe", "car"],
                ["Dostawcze", "truck"],
                ["Motocykle", "motorbikes"]
              ]}
              value={type}
              error={errors.type}
              rhf={register("type", { required: true })}
            />
            {type === "car" &&
              <CarInformations decodedCar={decodeResponse} watch={watch} setValue={setValue} errors={errors}
                               register={register} />
            }
            {type === "truck" &&
              <TruckInformations watch={watch} setValue={setValue} errors={errors} register={register} />
            }
            {type === "motorbikes" &&
              <MotoInformations watch={watch} setValue={setValue} errors={errors} register={register} />
            }
          </Grid>
        </Content>
        <Content>
          <Box marginBottom="S">
            <LabelH2 fontSize="XL" margin="0">Dodatkowe informacje</LabelH2>
            <P small>Podaj dodatkowe informacje o pojeździe</P>
          </Box>
          <Box marginBottom="S">
            <Grid>
              <Select
                name="state"
                label="Stan pojazdu*"
                options={[
                  ["Nowy", "brandNew"],
                  ["Używany", "used"]
                ]}
                error={errors.state}
                rhf={register("state", { required: true })}
              />
              <Input
                name="course"
                elementType="numeric"
                decimalScale={0}
                value={course}
                label="Przebieg*"
                endAdornment="km"
                error={errors.course}
                rhf={register("course", { required: true })}
              />
            </Grid>
          </Box>
          <Box marginBottom="S">
            <LabelH3>Wygląd zewnętrzny</LabelH3>
            <Grid marginTop="XS">
              <Select
                name="color"
                label="Kolor*"
                options={COLORS_ARRAY}
                error={errors.color}
                rhf={register("color", { required: true })}
              />
              <Select
                name="colorType"
                label="Typ koloru*"
                options={COLOR_TYPES_ARRAY}
                error={errors.colorType}
                rhf={register("colorType", { required: true })}
              />
            </Grid>
          </Box>
          <Box>
            <LabelH3>Inne</LabelH3>
            <Grid marginTop="XS">
              <Select
                name="country"
                label="Kraj pochodzenia*"
                options={COUNTRY_ARRAY}
                error={errors.country}
                value={watch("country")}
                rhf={register("country", { required: true })}
              />
              {
                !decodeResponse &&
                <Input name="vin" label="VIN" error={errors.vin} rhf={register("vin", { required: false })} />
              }
            </Grid>
          </Box>
        </Content>
        <Content>
          <Box marginBottom="S">
            <LabelH2 fontSize="XL" margin="0">Cena pojazdu</LabelH2>
            <P small>Podaj cene pojazdu</P>
          </Box>
          <Grid mobile="1fr" gtc="1fr 1fr">
            <Input
              name="price"
              elementType="numeric"
              decimalScale={0}
              value={price}
              label="Cena (brutto)*"
              endAdornment="zł"
              error={errors.price}
              margin="0"
              rhf={register("price", { required: true })}
            />
          </Grid>
          <Box marginTop="S">
            <CheckboxesGroup
              name="invoice"
              value={[invoice]}
              onChange={({ value }) => setInvoice(value[value.length - 1] ?? "none")}
              options={[
                ["Brak faktury", "none"],
                ["Faktura VAT", "vat"],
                ["Faktura VAT marża", "vat_discount"]
              ]}
            />
          </Box>
        </Content>
        {
          type !== "motorbikes" &&
          <Content>
            <EquipmentHeader marginBottom="S">
              <Box>
                <LabelH2 fontSize="XL" margin="0">Wyposażenie pojazdu</LabelH2>
                <P small margin="0">Dodaj wyposażenie swojego pojazdu</P>
              </Box>
              {/*<Box>*/}
              {/*  <Button icon="check" color="green" background="greenBackground" hoverBackground="greenBackground" hoverColor="greenDarker" onClick={handleEquipmentAuto}>*/}
              {/*    Wypełnij wyposażenie automatycznie*/}
              {/*  </Button>*/}
              {/*</Box>*/}
            </EquipmentHeader>
            <ButtonsWrapper>
              <Button
                type={equipmentState === "security" ? "primary" : "secondary"}
                onClick={() => setEquipmentState("security")}
                width="max-content"
              >
                Bezpieczeństwo
              </Button>
              <Button
                type={equipmentState === "comfort" ? "primary" : "secondary"}
                onClick={() => setEquipmentState("comfort")}
                width="max-content"
              >
                Komfort
              </Button>
              <Button
                type={equipmentState === "assistant" ? "primary" : "secondary"}
                onClick={() => setEquipmentState("assistant")}
                width="max-content"
              >
                Systemy wspomagające
              </Button>
              <Button
                type={equipmentState === "audio" ? "primary" : "secondary"}
                onClick={() => setEquipmentState("audio")}
                width="max-content"
              >
                Audio i multimedia
              </Button>
            </ButtonsWrapper>
            <EquipmentContent>
              <CheckboxesGroup
                name="states"
                value={equipment}
                onChange={({ value }) => setEquipment(value)}
                options={equipmentState === "security" ? SECURITY_ARRAY : equipmentState === "comfort" ? COMFORT_ARRAY : equipmentState === "assistant" ? ASSISTANT_ARRAY : MULTIMEDIA_ARRAY}
                marginBottom="S"
              />
            </EquipmentContent>
          </Content>
        }
        <Content>
          <Box marginBottom="S">
            <LabelH2 fontSize="XL" margin="0">Zdjęcia</LabelH2>
            <P small>Dodaj zdjęcia swojego pojazdu</P>
          </Box>
          <AddOfferGallery images={images} setImages={setImages} />
          <Input
            name="youtube"
            value={youtube}
            label="Link do YouTube*"
            error={errors.youtube}
            margin="0"
            rhf={register("youtube", {
              required: false,
              pattern: {
                value: /^http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-_]*)(&(amp;)?[\w?=]*)?/,
                message: "Niepoprawny format linku"
              }
            })}
            marginTop="S"
          />
        </Content>
        <Content>
          <Box marginBottom="S">
            <LabelH2 fontSize="XL" margin="0">Opis oferty</LabelH2>
            <P small>Dodaj opis oferty z dodatkowymi informacjami</P>
          </Box>
          <Box>
            <Input
              name="description"
              label="Opis"
              value={description}
              error={errors.description}
              margin="0"
              rhf={register("description")}
              multiline
              rows={12}
            />
          </Box>
        </Content>
        <SubmitWrapper>
          <Button width="100%" loading={loading} onClick={handleSubmit(onSubmit)}>
            Dodaj ogłoszenie
          </Button>
        </SubmitWrapper>
      </Wrapper>
      <Modal title="Udało się!" show={!!data}>
        <Box
          borderRadius="50%"
          margin="0 auto"
          height="200px"
          width="200px"
        >
          <Box width="100%" height="100%">
            <NextImage
              fill
              objectFit="contain"
              priority={true}
              src="/images/send.png"
              alt="Grafika dodanej oferty"
            />
          </Box>
        </Box>
        <P small textAlign="center">
          Twoje ogłoszenie zostało pomyślnie dodane do naszego serwisu.
        </P>
        <Link width="100%" type="secondary" href="/konto">
          Wszystkie ogłoszenia
        </Link>
        <Link marginTop="XS" href={`/oferta/${data?.id}`}>
          Dodane ogłoszenie
        </Link>
      </Modal>
    </>
  );
};

export default AccountAddOffer;

const ButtonsWrapper = styled(Box)`
  display: flex;
  grid-gap: ${({ theme }) => theme.space.XS};
  margin-bottom: ${({ theme }) => theme.space.S};
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    > * {
      width: 100%;
    }
  }
`;

const Grid = styled(Box)<{
  mobile?: string
}>`
  display: grid;
  grid-template-columns: ${({ gtc = "1fr 1fr 1fr 1fr" }) => gtc};
  grid-gap: ${({ theme }) => theme.space.XS};
  grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 600px) {
  grid-template-columns: ${({ mobile = "1fr 1fr" }) => mobile};
}
`;

const EquipmentContent = styled(Box)`
  >div>div {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    
    >button{
      label {
        text-align: left;
      }
    }
    
    @media (max-width: 800px){
      grid-template-columns: 1fr 1fr;
    }
  }
  `;

const EquipmentHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  grid-gap: ${({ theme }) => theme.space.S};
  
  @media (max-width: 1000px){
    flex-direction: column;
    align-items: flex-start;
    
    >div:nth-child(2){
      width: 100% !important;
      >*{
        width: 100% !important;
      }
    }
  }
  `;

const Content = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.color.fourth};
  padding: ${({ theme }) => theme.space.M} 0;
`;

const Wrapper = styled(Box)`
  > div:first-of-type {
    padding-top: 0;
  }
`;

const SubmitWrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.M} ${({ theme }) => theme.space.S};
`;
